import Accordion from "./accordion";
import Tabs from "./tabs";
import StickyBlock from "./stickyBlock";
import supportSearch from "./supportSearch";
import scrollTop from "../utils/scrollTop";

const initSupport = () => {

    const
        supportAccordion = new Accordion('.js-support-title', '.js-support-accordion' ),
        stickySupportArchive = new StickyBlock('.js-sticky-support-archive', '.js-sticky-support-archive-wrapper', 1250),
        supportTabs = new Tabs('.js-support-tab-link',() => {
            stickySupportArchive.destroy();
            stickySupportArchive.init();
            scrollTop();
        });

    const addHashToUrl = ($elem) => {
        if ( location.hash !== ('#' + $elem.data('slug') ) ) {
            location.hash = '#' + $elem.data('slug');
        }
    }

    const goToItemFromUrl = () => {

        const hash = location.hash;

        if ( hash && $(document.body).hasClass('post-type-archive-support') ) {

            const $elem = $('[data-slug=' + hash.replace('#', '') + ']');

            if ( $elem.hasClass('js-support-tab-link') ) {

                $elem.trigger('click');

            } else if ( $elem.hasClass('js-support-title') ) {

                $('.post-type-archive-support [data-slug='+$elem.closest('.js-tab').data('container')+']').trigger('click');

                $elem.trigger('click');

                $('html, body').animate({
                    'scrollTop': $elem.offset().top - 94
                }, 1000);
            }
        }

    }

    supportAccordion.init();
    supportTabs.init();
    stickySupportArchive.init();
    supportSearch();

    goToItemFromUrl(); 

    $('.js-support-tab-link, .js-support-title').on('click', (event) => {
        const $elem = $(event.currentTarget);
        const hash = location.hash;

        if ( hash !== '#' + $elem.data('slug') ) {
            addHashToUrl($elem);
            supportAccordion.openAccordion(event);
        }
    });

};

export default initSupport;

document.addEventListener('DOMContentLoaded', function() {
    let readMoreButtons = document.querySelectorAll('.btn__read-more');

    readMoreButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            let moreContent = button.closest('.support__item__content').querySelector('.more-content');
            moreContent.style.display = 'block';
            button.style.display = 'none';
        });
    });

});